<script>
import Layout from "../../layouts/main";
//import appConfig from "@/app.config";
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
export default {
  /*page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },*/
  components: {
    Layout, /*swiper, swiperSlide*/
  },
  data() {
    return {

      mediaFeaturesVisible: false,
      iconsVisible: false,

      bannerList: [],
      icons: [
        { imgSrc: 'car-3-svgrepo-com', altText: 'default.icons.1.altText', text: 'default.icons.1.text' },
        { imgSrc: 'family-of-3-whole-body-svgrepo-com', altText: 'default.icons.2.altText', text: 'default.icons.2.text' },
        { imgSrc: 'plane-svgrepo-com', altText: 'default.icons.3.altText', text: 'default.icons.3.text' },
        { imgSrc: 'tray-dish-svgrepo-com', altText: 'default.icons.4.altText', text: 'default.icons.4.text' }
      ],

      imagesCount: 18,

      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "m1",
        alt: "m1",
        title: "default.mediaFeatures.1.title",
      },
      {
        id: "2",
        icon: "m2",
        alt: "m2",
        title: "default.mediaFeatures.2.title",
        description: "default.mediaFeatures.2.description"
      },
      {
        id: "3",
        icon: "m3",
        alt: "m3",
        title: "default.mediaFeatures.3.title",
        description: "default.mediaFeatures.3.description"
      },
      {
        id: "4",
        icon: "m4",
        alt: "m4P",
        title: "default.mediaFeatures.4.title",
        description: "default.mediaFeatures.4.description"
      },
      {
        id: "5",
        icon: "m5",
        alt: "m5P",
        title: "default.mediaFeatures.5.title",
        description: "default.mediaFeatures.5.description"
      }
      ],

      menuFeatures: [
        {
          title: "Menu digital & dynamique",
          // description: "Mise en valeur des articles, modification instantanée sans supports papier obsolètes.",
          descriptions:[	"Mise en valeur des articles avec images",
                          "Meilleure expérience client",
                          "Pas de supports physiques obsolètes",
                          "Modification instantanée du menu (sans impression)"],
          icon: "/icons/features/menu.svg",
          image: "/images/features/menu.png"
        },

        {
          title: "Passage de commande",
          // description: "Gain de temps, réduction des erreurs et traçabilité complète des commandes.",
          descriptions:[	"Gain de temps pour les serveurs et les clients",
                "Efficacité & moins d’erreurs lors de la prise de commandes",
                "Meilleure gestion des commandes",
                "Traçabilité"],
          icon: "/icons/features/order.svg",
          image: "/images/features/order.png"
        },
        {
          title: "Tableau de bord",
          // description: "Pilotage par KPIs, CA, et suivi de la trésorerie en temps réel.",
          descriptions:[	"Pilotage, suivi et contrôle de l’activité grâce aux KPIs disponibles",
                "Articles les plus consultés / commandés",
                "Chiffre d’affaires",
                "Suivi en temps réel de la trésorerie",
                "Analyse comparative de la trésorerie"],
          icon: "/icons/features/dashboard.svg",
          image: "/images/features/dashboard.png"
        },
        {
          title: "Deux Bannières promotionnelles",
          // description: "Nouveau canal de communication pour vos promos et événements.",
          descriptions:[	"Canal de communication avec ses clients",
                "Communication sur les futurs événements",
                "Promotion d’articles / événements en fonction des besoins / actualités"],
          icon: "/icons/features/banner.svg",
          image: "/images/features/banner.png"
        },
        {
          title: "Collecte de données",
          // description: "Fichier clients, sondages, avis et jeux pour fidéliser votre audience.",
          descriptions:["Collecte des données clients",
                "Interaction avec les clients (sondages, réclamations, avis, jeux…)"],
          icon: "/icons/features/data.svg",
          image: "/images/features/data.png"
        },
        {
          title: "Bouton appel serveur",
          // description: "Demande d’addition ou débarrassage pour fluidifier le service.",
          descriptions:["Proposition de services aux clients (demande d’addition, débarrassage de la table…)",
                "Fluidification de la communication entre les clients et les serveurs",
                "Gain de temps pour les serveurs et les clients"],
          icon: "/icons/features/call.svg",
          image: "/images/features/call.png"
        },
        {
          title: "Insta & Google",
          // description: "Boostez vos avis Google et augmentez votre trafic Instagram.",
          descriptions:["Plus d’avis Google et trafic Instagram (accès rapide et simple)"],
          icon: "/icons/features/social.svg",
          image: "/images/features/social.png"
        },
        {
          title: "Multi-langue",
          descriptions: ["Menu disponible en plusieurs langues pour votre clientèle internationale."],
          icon: "/icons/features/language.svg",
          image: "/images/features/language.png"
        }
      ],

      swiperOption: {
        slidesPerView: 6,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 6
          }
        },
        spaceBetween: 20
      },

      advantageOptions: [
        {
          id: 1,
          title: "Gagnez du temps",
          description: "Moins d’attente, moins d’allers-retours, plus de fluidité dans le service.",
        },
        {
          id: 2,
          title: "Réduisez les coûts",
          description: "Fini les menus papier, les impressions répétées et les erreurs de commande.",
        },
        {
          id: 3,
          title: "Boostez vos ventes",
          description: "Mettez en valeur vos articles grâce à des photos et vidéos appétissantes.",
        },
        {
          id: 4,
          title: "Collectez des données clients exploitables",
          description: "Analysez les habitudes de consommation et améliorez vos décisions commerciales.",
        },
        {
          id: 5,
          title: "Modernisez l’expérience de vos clients",
          description: "Offrez une expérience fluide, intuitive et innovante.",
        },
      ],

      orderOnlineOptions: [
        {
          id: 1,
          icon: "share-icon.svg",
          title: "Lien direct",
          description: "Passage de commande via lien depuis votre site web / page Instagram.",
        },
        {
          id: 2,
          icon: "qr-icon.svg",
          title: "QR Code Intelligent",
          description: "Un scan unique pour commander sans attendre.",
        },
        {
          id: 3,
          icon: "data-line.svg",
          title: "Collecte de données",
          description: "Recevoir les éléments nécessaires à la commande (nom, prénom, adresse, numéro de téléphone…) ",
        },
      ],

      orderOnlineMethodes: [
        {
          id: 1,
          icon: "ImageBackground1",
          title: "Instagram",
          description: "Lien direct en bio",
        },
        {
          id: 2,
          icon: "ImageBackground2",
          title: "Site Web",
          description: "Intégration fluide",
        },
        {
          id: 3,
          icon: "ImageBackground3",
          title: "QR Code",
          description: "Scan rapide",
        },
      ],



      counterItems: [
        {
          alt: 'bag',
          width: '70px',
          icon: 'bag-w.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 100000,
          duration: 3000,
          title: 'ourPartner.bag',
          subTitle: 'ourPartner.distributed',
          perDay: 'ourPartner.perDay'
        },
        {
          alt: 'bread',
          width: '70px',
          icon: 'bread.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 500,
          duration: 4000,
          title: 'ourPartner.partners',
          subTitle: 'ourPartner.intunisia',
          perDay: ''
        },
        {
          alt: 'capsules',
          width: '70px',
          icon: 'capsules.svg',
          moreThanText: 'ourPartner.moreThan',
          endVal: 3,
          duration: 4000,
          title: 'ourPartner.cibles',
          subTitle: 'ourPartner.ciblesPer',
          perDay: ''
        }
      ]


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },
  },


  mounted() {
    this.findBanner(this.windowWidth);

  },

  methods: {

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

  }
};
</script>

<template>
  <Layout>

    <!-- Main Banners -->
    <div class="row pt-xl-0" >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

                <b-carousel-slide class="bg-primary"  
                          style="width:1920px; height:565px;" 
                          img-blank img-alt="Blank Image " 
                          img-width="1900"
                img-height="400" 
                          v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                  <!-- <p class="text-info">
                    caption="Restez à l'écoute!" 
                    Les publicitées seront disponibles prochainement
                  </p> -->

                </b-carousel-slide> 

                <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                  <template #img>
                    <div class="banner-overlay"></div>
                    <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" height="100%">
                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left d-none d-md-block">
                   
                  <h1 class="d-none d-sm-block text-primary text-uppercase mt-4 banner-title"> {{ $t('default.bannerTitle') }} </h1>

                  <h2 class="d-none d-lg-block text-primary font-weight-bold font-size-24 mt-5 mb-4" style="max-width: 50%;">
                    {{ $t('default.bannerSubTitle1') }}
                  </h2>

                  <h2 class="d-none d-lg-block text-dark font-weight-bold font-size-20 mt-2 banner-title" style="max-width: 50%;">
                    {{ $t('default.bannerSubTitle2') }}
                  </h2>

                  <div class="mt-3 mt-lg-5">
                    <a class="pr-3" href="/solution-cafe-hotel-restaurant">
                      <b-button variant="secondary"  style="padding: 10px 26px; letter-spacing:3px; border-radius: 10px;" class="font-weight-bold font-size-18">
                        {{ $t('default.bannerButton1') }} 
                      </b-button>
                    </a>    
                    
                    <a class="pl-3" href="/contacter-nous">
                      <b-button
                        class="font-weight-bold font-size-18 shadow bg-white"
                        style="padding: 10px 26px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); border-color: white;"
                      >
                        <span class="text-primary">{{ $t('default.bannerButton2') }}</span>
                      </b-button>

                    </a>
                  </div>
                </div>

            </b-carousel>

            <!-- Mobile text below banner -->
            <div class="d-md-none text-center px-3 py-4 bg-white">
              <h3 class="font-weight-bold text-primary banner-title-mobile" style="font-size:1.6rem; letter-spacing: 1.4px;">{{ $t('default.bannerTitle') }}</h3>
              <p class="text-primary mt-3 banner-title-mobile" style="font-size:0.95rem; max-width: 90%; margin: auto;">
                {{ $t('default.bannerSubTitle1') }}
              </p>
              <p class="text-dark font-weight-bold mt-2 banner-title-mobile" style="font-size:0.85rem;">
                {{ $t('default.bannerSubTitle2') }}
              </p>
              <div class="mt-4 d-flex justify-content-center gap-2">
                <a href="/solution-cafe-hotel-restaurant" class="mr-2">
                  <b-button
                    variant="secondary"
                    size="sm"
                    class="font-weight-bold"
                    style="font-size: 12px; padding: 8px 16px; letter-spacing: 1px; border-radius: 8px;"
                  >
                    {{ $t('default.bannerButton1') }}
                  </b-button>
                </a>
                <a href="/contacter-nous" class="ml-2">
                  <b-button
                    size="sm"
                    class="font-weight-bold bg-white shadow"
                    style="font-size: 12px; padding: 8px 16px; border-radius: 8px; border-color: white;"
                  >
                    <span class="text-primary">{{ $t('default.bannerButton2') }}</span>
                  </b-button>
                </a>
              </div>
            </div>

        </div>
      </div>


    </div>

    

    <section id="features" class="features-section mt-3 mt-md-4">

      <div class="container">

        <div class="text-center mb-5">
          <h3 class="ml-2 text-primary sectionTitle mt-5">FONCTIONNALITÉS / AVANTAGES</h3>

          <p class="features-subtitle px-3 px-md-0">
            Découvrez comment nos outils réinventent le quotidien de votre établissement.
          </p>
        </div>

        <div class="row">

          <div
            class="col-xl-3 col-lg-4 col-sm-6 col-12 mb-4"
            v-for="(feature, index) in menuFeatures"
            :key="index"
          >
            <div class="feature-card mx-3">

              <img
                :src="require('@/assets' + feature.image )"
                class="feature-image"
              />

              <div class="feature-body">

                <div class="feature-icon">
                  <img
                    :src="require('@/assets' + feature.icon )"
                  />
                </div>

                <h5 class="feature-title">
                  {{ feature.title }}
                </h5>

                <div v-for="(description, index) in feature.descriptions" 
                  :key="index"
                  class="feature-text text-dark my-1">
                  {{ description }}
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>

    </section>
  

    <!-- 5 points section -->
    <div class="py-3 py-md-5 px-3 px-md-0 text-center bg-light" >

      <h1 class="pt-2 pt-md-3 text-primary font-weight-bold " style="font-size:2rem; letter-spacing: 1.4px;">
        {{$t("default.title")}}
      </h1>

      <p class="features-subtitle">
        {{$t("default.subTitle")}}
      </p>

        <div class="pt-3 pt-md-4 pb-3 pb-md-4 d-none d-md-block">
        <div
          ref="mediaFeaturesSection"
          class="row justify-content-center g-4 gy-4 header-70-width mx-auto"
        >
          <div
            v-for="feature in mediaFeatures"
            :key="feature.id"
            class="col-12 col-sm-6 col-md-4 col-lg-4 feature-item mb-4"
          >
            <div class="d-flex align-items-center  justify-content-center ">
              <div class="icon-pill">
                <img
                  v-if="feature.icon"
                  :src="require('@/assets/icons/' + feature.icon + '.png')"
                  :alt="feature.alt"
                />
              </div>

              <div class="text-content ml-3 ms-3 text-left">
                <div class="feature-title text-primary">
                  {{ $t(feature.title) }}
                </div>
                <div v-if="feature.description" class="feature-subtitle">
                  {{ $t(feature.description) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="pt-2 pb-3 px-2 d-md-none">

          <div ref="mediaFeaturesSection" class="row no-gutters">
            <div
              v-for="feature in mediaFeatures"
              :key="feature.id"
              class="col-6 px-2 my-2"
            >
              <div class="card my-2 h-100"  style="border-radius: 20px;">
                <div class="card-body d-flex align-items-center p-1 pl-2">
                  <img
                    v-if="feature.icon"
                    :src="require('@/assets/icons/' + feature.icon + '.png')"
                    :alt="feature.alt"
                    height="36"
                  />

                  <div class="ml-2 text-left">
                    <div class="feature-title-mobile text-primary">
                      {{ $t(feature.title) }}
                    </div>
                    <div v-if="feature.description" class="feature-subtitle-mobile">
                      {{ $t(feature.description) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <!-- 5 points section -->
      <div class="py-5 bg-light" >
        <div class="row d-flex flex-wrap justify-content-center align-items-center gap-4 header-80-width mx-auto">
          <div class="col-xl-5 col-12 text-white mx-auto">

            <h3 class="text-primary sectionTitle">Passage de commande en ligne</h3>

            <p class="mt-4 sectionSubTitle" style="letter-spacing: 1.5px; line-height: 1.9;">
              En plus, DIGITABLE vous permet de recevoir et de gérer vos commandes à distance grâce au passage de commande en ligne.               
            </p>

            <div class="pt-5 pb-4 d-none d-md-block">
              <div
                ref="mediaFeaturesSection"
                class=" flex-wrap justify-content-start align-items-start gap-4  mx-auto"
              >
                <div
                  v-for="option in orderOnlineOptions"
                  :key="option.id"
                >
                  <div class="d-flex align-items-center my-2 item-pill w-100 ">
                    <div>
                      <img
                      class="ml-3"
                        v-if="option.icon"
                        :src="require('@/assets/icons/' + option.icon)"
                        :alt="option.alt"
                      />
                    </div>

                    <div class="text-content ml-3 text-left">
                      <div class="feature-title text-primary">
                        {{ $t(option.title) }}
                      </div>
                      <div v-if="option.description" class="feature-subtitle mt-2">
                        {{ $t(option.description) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="pt-3 pb-2 d-block d-md-none">
              <div v-for="option in orderOnlineOptions" :key="option.id">
                <div class="d-flex align-items-center my-2 item-pill w-100">
                  <div>
                    <img
                      class="ml-3"
                      v-if="option.icon"
                      :src="require('@/assets/icons/' + option.icon)"
                      :alt="option.alt"
                    />
                  </div>
                  <div class="text-content ml-3 text-left">
                    <div class="feature-title text-primary">{{ $t(option.title) }}</div>
                    <div v-if="option.description" class="feature-subtitle mt-1">{{ $t(option.description) }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-xl-7 col-12 d-none d-lg-flex align-items-center justify-content-center">

            <div class="d-flex">
                <div
                  v-for="option in orderOnlineMethodes"
                  :key="option.id"
                  class=" mx-2"
                >
                  <div>
                    <img
                      class="orderOnlineMethodesImage"
                        v-if="option.icon"
                        :src="require('@/assets/images/background/' + option.icon + '.png')"
                        :alt="option.alt"
                        style="height: auto;"
                      />
                  </div>

                  <div class="text-content mt-2 text-left">
                    <div class="feature-title text-primary">
                      {{ $t(option.title) }}
                    </div>
                    <div v-if="option.description" class="order-online-subtitle text-uppercase mt-1">
                      {{ $t(option.description) }}
                    </div>
                  </div>

                </div>
              </div>
            

          </div>

        </div>

      </div>


      <!-- NOS REFERENCES -->
      <div id="references" class="references-section">
        <div class="container">
          <div class="references-heading text-center mb-5">
            <span class="references-eyebrow">Ils nous font confiance</span>
            <h3 class="references-title">Des établissements qui ont choisi <span class="references-brand">Digitable</span></h3>
            <div class="references-divider"></div>
          </div>

          <div class="logo-grid">
            <div class="logo-card" v-for="n in imagesCount" :key="n">
              <img
                :src="require('@/assets/images/references/' + n + '.png')"
                :alt="'logo-' + n"
              />
            </div>
          </div>
        </div>
      </div>

        <div class="" style="background: linear-gradient(to bottom, #f6f6f6 0%, #c9ccd7 50%, #f6f6f6 100%);">

            <div class="row">

              <div class="col-lg-6 col-12 text-white p-md-5 p-3 my-auto">
                <h3 class="ml-2 text-primary sectionTitle">Simplifiez votre service et augmentez vos ventes</h3>

                <p
                  class="mt-4 sectionSubTitle"
                  style="letter-spacing: 1.5px; line-height: 1.9;"
                >
                  DIGITABLE transforme votre établissement en un espace connecté, moderne et performant.
                </p>


                <div class="">
                  <div
                    ref="mediaFeaturesSection"
                    class="row mx-auto"
                  >
                    <div
                      v-for="option in advantageOptions"
                      :key="option.id"
                      class="offer-section col-12"
                    >
                      <div class="d-flex align-items-center my-2 ">
                        <div class="icon-pill">
                          <img :src="require('@/assets/icons/Overlay.svg')"/>
                        </div>

                        <div class="text-content ml-3 text-left">
                          <div class="feature-title text-info">
                            {{ $t(option.title) }}
                          </div>
                          <div v-if="option.description" class="feature-subtitle">
                            {{ $t(option.description) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-lg-6 col-12 d-none d-lg-flex align-items-center justify-content-center">
                <img  class="p-md-5 p-3" src="@/assets/images/digitable-platforme.png" alt="Partaires DigiTable" width="100%" style="border-radius: 75px; filter: blur(4px);"  />
              </div>

            </div>

        </div>
  


    
        <div class="py-3 py-md-5 cta-section">

          <div class="py-2 py-md-5">

            <div class="card-80-width mx-auto cta-card">

              <div class="corner-circle-right"></div>

              <div class="corner-circle-left"></div>

              <div class="text-center w-100">
                <div class="text-white font-weight-bold cta-title">
                  Prêt à transformer votre restaurant ?
                </div>

                <div class="mt-3 cta-sub">
                  Rejoignez des centaines d'établissements qui nous font déjà confiance.
                </div>

                <div class="mt-1 cta-sub">
                  Une solution tout-en-un, sans installation de matériel coûteux.
                </div>

                <div class="d-flex justify-content-center gap-3 mt-4 flex-wrap">

                  <button class="btn btn-light cta-btn-primary">
                    Prendre Rendez-vous
                  </button>

                  <button class="btn btn-outline-light cta-btn-secondary">
                    Voir les Tarifs
                  </button>

                </div>

              </div>

            </div>

          </div>

        </div>

  </Layout>
</template>

<style scoped>



.banner-overlay {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 60%, #f6f6f6 100%);
  background-size: cover;
  background-position: center;
  
  /* Create a slight blur effect */
  filter: blur(5px);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  text-align: center;
  
  transition: filter 0.3s ease, opacity 0.3s ease;
}

/* Hover Effect (Optional: Adds a modern interaction on hover) */
/* .banner-overlay:hover {
  filter: blur(5px);
  opacity: 0.8; 
} */

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6);  */
  font-weight: 700;
}
@media (min-width: 768px) and (max-width: 991px) {
  .banner-title {
    font-size: 2rem;
  }

  /* Force a minimum visible height so the overlay caption doesn't overflow */
  .carousel-item,
  .carousel-item img,
  .carousel-item .card-img {
    min-height: 320px;
    object-fit: cover;
  }
}

@media (min-width: 992px) {
  .banner-title {
    font-size: 4rem;
  }
}

/* Mobile Version */

.banner-title-mobile {
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff; 
}

.carousel-caption-mobile {
  position: absolute;
  padding-left: 5%;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
}


.carousel-caption {
  position: absolute;
  padding-left: 5%;
  top: 48%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 768px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.left-border {
  border-left: 3px solid #1d3266;
  padding-left: 10px;
}


.header {
    background:  linear-gradient(19deg,#37985b 0%,#1d3266 , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }

.header-70-width,
.sub-title-70-width {
  max-width: 80%;
  margin: auto;
}

.header-80-width,
.sub-title-80-width {
  max-width: 90%;
  margin: auto;
}

.card-80-width {
  width: 90%;
}

@media (min-width: 768px) {
  .header-70-width,
  .sub-title-70-width {
      max-width: 70%;
  }

  .header-80-width,
  .sub-title-80-width {
      max-width: 80%;
  }

  .card-80-width {
  width: 80%;
}
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #1d3266; /*#f7d584 ;*/
  border: none;
  margin: auto;
}

.sub-title-70-width {
  margin: 30px auto 0;
  color: #f7d584;
}



</style>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fadeInUp {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fadeInUp.animate {
  animation: fadeInUp 0.6s ease-in-out forwards;
}
</style>

<style scoped>
.rubon78 {
  background-image: url('~@/assets/images/rubon78.jpg'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
}

.rubon79 {
  background-image: url('~@/assets/images/digitable-menu.png'); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
}






.image-overlay {
  background: #294639c9  ; 
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
}


</style>


<style scoped>
.circle-icon {
  display: inline-block;
  background-color: #252525;
  border-radius: 50%;
  padding: 20px;
  width: 120px;
  height: 120px; 
  opacity: 0.7;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.circle-icon img {
  width: 60px;
  height: 60px; 
}

.white-box {
  background-color: #fff;
  max-width: 600px;
  transform: translateY(-100px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
}

fieldset.scheduler-border {
  border: 2px solid #1d3266;
  padding: 1.5em;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

legend.scheduler-border {
  font-size: 1.4em;
  font-weight: bold;
  color: #1d3266;
  padding: 0 10px;
  text-align: center;
}

.control-group {
  margin-top: 10px;
  line-height: 1.6;
}



</style>


<style scoped>
.image-slide-in {
  width: 400px;
  transform: translateX(-100%);
  opacity: 0; 
  transition: transform 1s ease-out, opacity 1s ease-out;
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}

.dashboard-image {
    width: 100%;
    max-width: 600px;
    border: 8px solid #1d3266;
    border-radius: 10px;
    box-shadow: 0 10px 20px #1d326693;
    transform: rotate(0deg); /* Initial rotation */
    transition: transform 1s ease-out, box-shadow 1s ease-out; /* Add transition for rotation */
}

.image-slide-right-in {
    width: 600px;
    transform: translateX(100%); /* Initially off-screen to the right */
    opacity: 0;
    transition: transform 1s ease-out, opacity 1s ease-out; /* Sliding effect */
}

.image-slide-right-in.animate {
    transform: translateX(0) rotate(0deg); /* Slide to normal position and apply rotation */
    opacity: 1;
}

@media (max-width: 450px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 270px;
  }
}

@media (min-width: 450px) and (max-width: 1300px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 360px;
  }
}

.feature-item {
  min-width: 240px;
}

.icon-pill {
  width: 54px;
  height: 54px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-pill img {
  width: 30px;
  height: 30px;
}

.item-pill {
  margin-top: 10px;
  height: 76px;
  background: #ffffff;
  border-radius: 15px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
  display: flex;
  align-items: center;
  justify-content: start;
  flex-shrink: 0;
}

.item-pill img {
  width: 30px;
  height: 30px;
}

.text-content {
  line-height: 1.2;
}

.feature-title {
  font-size: 16px;
  font-weight: 600;
}

.feature-subtitle {
  font-size: 14px;
  color: #000;
}

.order-online-subtitle {
  font-size: 12px;
  line-height: 16px;
  color: #000;
}

.feature-title-mobile {
  font-size: 11px;
  font-weight: 600;
}

.feature-subtitle-mobile {
  font-size: 10px;
  color: #000;
}


@media (max-width: 768px) {
  .feature-item {
    min-width: 100%;
  }
}

@media (max-width: 576px) {
  .feature-card {
    margin-left: 4px;
    margin-right: 4px;
  }

  .references-section {
    padding: 50px 0 40px;
  }

  .references-title {
    font-size: 20px;
  }

  .references-eyebrow {
    font-size: 10px;
    letter-spacing: 2px;
  }

  .sectionSubTitle {
    font-size: 15px;
  }
}


.customersSectionTitle{
  color: #000;
  font-size: 14px;
  letter-spacing: 1.4px;
  line-height: 20px;
}


.sectionTitle{
  font-size: 1.6rem;
  line-height: 36px;
  font-weight: bolder;
}

@media (min-width: 768px) {
  .sectionTitle {
    font-size: 2.8rem;
    line-height: 48px;
  }
}

.sectionSubTitle{
  font-size: 18px;
  line-height: 28px;
  color: #000;
  font-weight: normal;
}



.cta-section{
  background: linear-gradient(to bottom, #f6f6f6 0%, #c9ccd7 50%, #f6f6f6 100%);
}

.cta-card{
  background-color:#003366;
  border-radius:16px;
  padding:48px 64px;
  position:relative;
  overflow:hidden;
}

@media (max-width: 768px){
  .cta-card{
    padding:65px 5px;
  }
}

.cta-title{
  font-size:22px;
  line-height:28px;
}

@media (min-width: 768px) {
  .cta-title {
    font-size:36px;
    line-height:40px;
  }
}

.cta-sub{
  font-size:14px;
  color:#bebdbd;
  font-weight:300;
}

.cta-btn-primary{
  font-weight:600;
  padding:10px 24px;
  border-radius:8px;
}

.cta-btn-secondary{
  font-weight:600;
  padding:10px 24px;
  border-radius:8px;
  color: #ffffff;
}

.cta-btn-secondary:hover{
  color: #003366;
}


.gap-3{
  gap:16px;
}

/* Quart de cercle */
.corner-circle-right{
  position: absolute;
  width: 280px;
  height: 280px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
  top: -100px;
  right: -90px;
}

.corner-circle-left{
  position:absolute;
  width:180px;
  height:180px;
  background:rgba(255,255,255,0.06);
  border-radius:50%;
  bottom:-90px;
  left:-90px;
}


/*.features-section{
  padding:40px 0;
  background:#f7f8fb;
}

@media (min-width: 768px) {
  .features-section {
    padding:80px 0;
  }
}*/

.features-title{
  font-size:36px;
  font-weight:800;
  color:#1d2433;
}

.features-subtitle{
  color:#000000;
  font-size:15px;
}

.feature-card{
  background:white;
  border-radius:14px;
  overflow:hidden;
  box-shadow:0 6px 20px rgba(0,0,0,0.05);
  transition:all .3s;
  height:100%;
}

.feature-card:hover{
  transform:translateY(-6px);
  box-shadow:0 10px 30px rgba(0,0,0,0.08);
}

.feature-image{
  width:100%;
  height:150px;
  object-fit:cover;
}

/*@media (min-width: 768px) {
  .feature-image {
    height:150px;
  }
}*/

.feature-body{
  padding:20px;
}

.feature-icon{
  width:36px;
  height:36px;
  background:#0b3a66;
  color:white;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:8px;
  margin-bottom:10px;
}


.feature-title{
  font-weight:700;
  font-size:16px;
  margin-bottom:6px;
}

.feature-text{
  font-size:13px;
  color:#000;
}

.feature-text {
  position: relative;
  padding-left: 12px;
}

.feature-text::before {
  content: "•";
  position: absolute;
  left: 0;
}


.orderOnlineMethodesImage{
  width: 200px;
}

@media (max-width: 1390px) {
  .orderOnlineMethodesImage {
    width: 170px;
  }
}











.references-section {
  background: linear-gradient(180deg, #f9fafb 0%, #ffffff 100%);
  padding: 80px 0 70px;
  text-align: center;
  border-top: 1px solid #eef0f4;
  border-bottom: 1px solid #eef0f4;
}

.references-heading {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 24px;
}

.references-eyebrow {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #1d3266;
  opacity: 0.55;
  margin-bottom: 12px;
}

.references-title {
  font-size: 28px;
  font-weight: 700;
  color: #1d3266;
  letter-spacing: 0.3px;
  line-height: 1.3;
  margin-bottom: 16px;
}

.references-brand {
  font-weight: 800;
}

.references-divider {
  width: 48px;
  height: 3px;
  background: #1d3266;
  border-radius: 2px;
  margin: 0 auto;
  opacity: 0.3;
}

.logo-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  justify-items: center;
  align-items: center;
}

@media (max-width: 992px) {
  .logo-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 576px) {
  .logo-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
}

.logo-card {
  padding: 16px 12px;
  border-radius: 12px;
  transition: background 0.25s ease, box-shadow 0.25s ease;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 576px) {
  .logo-card {
    padding: 10px 6px;
    border-radius: 8px;
  }
}

.logo-card:hover {
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.logo-card img {
  width: 100%;
  max-width: 100px;
  max-height: 48px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

@media (max-width: 576px) {
  .logo-card img {
    max-width: 72px;
    max-height: 36px;
  }
}

.logo-card:hover img {
  transform: scale(1.06);
}

</style>